module.exports = __webpack_public_path__ + "media/buzz.30d58e3c.wav";